import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Spinner from '@atlaskit/spinner';
import CommonCell from './common-cell';
import { indentBase, LoaderItemContainer, TreeRowContainer } from './styled';
export default class LoaderItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      phase: 'loading'
    });
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isCompleting && prevState.phase === 'loading') {
      return {
        phase: 'complete'
      };
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.phase === 'loading' && this.state.phase === 'complete') {
      if (this.props.onComplete) {
        this.props.onComplete();
      }
    }
  }
  render() {
    const {
      depth,
      loadingLabel
    } = this.props;
    const {
      phase
    } = this.state;
    return phase === 'loading' ? /*#__PURE__*/React.createElement(TreeRowContainer, null, /*#__PURE__*/React.createElement(CommonCell, {
      indent: `calc(${indentBase} * ${depth})`,
      width: "100%"
    }, /*#__PURE__*/React.createElement(LoaderItemContainer, {
      isRoot: depth === 1
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "small",
      testId: "table-tree-spinner",
      label: loadingLabel
    })))) : null;
  }
}
_defineProperty(LoaderItem, "defaultProps", {
  depth: 1
});